import { type PropsWithChildren, type ReactNode } from 'react';
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/shared/components/ui/card';
import { cn } from '@/shared/utils/styling';
import { Button } from '@/shared/components/ui/button';
import { Link } from 'react-router-dom';
import ArrowLeftIcon from '@/shared/assets/arrow-left-icon.svg?react';

type Props = {
  title: string;
  description?: ReactNode;
  backButton?: {
    link: string;
    state?: Record<string, unknown>;
  };
  className?: string;
  titleClassName?: string;
};

const AuthCard = ({
  className,
  backButton,
  title,
  description,
  children,
  titleClassName,
}: PropsWithChildren<Props>) => {
  return (
    <Card
      className={cn(
        'p-[2.4rem] xl:p-[4.8rem] w-3lg lg:min-w-[35rem] min-w-full h-fit gap-0 border border-secondary-bg',
        className
      )}>
      <CardHeader className="mb-[2.4rem] xl:mb-[3.2rem] px-0 gap-0">
        <CardTitle
          className={cn(
            'flex flex-row items-center gap-4 p-0 headline0',
            titleClassName
          )}>
          {backButton && (
            <Button
              variant={'ghost'}
              asChild
              className="px-2 w-[3.2rem] h-[3.2rem]">
              <Link to={backButton.link} state={backButton.state}>
                <ArrowLeftIcon className="size-[2.4rem] text-foreground" />
              </Link>
            </Button>
          )}
          <span className="headline0">{title}</span>
        </CardTitle>
        {description && (
          <CardDescription className="mt-[1.6rem]">
            {description}
          </CardDescription>
        )}
      </CardHeader>
      {children}
    </Card>
  );
};

export { AuthCard };
